import { FunctionComponent } from "react";
import { UserAvatar } from "../UserAvatar/UserAvatar";
import { UserSignIn } from "../UserSignIn/UserSignIn";
import { useAppSelector } from "@store/store";
import { selectClient } from "@store/client/clientReducer";
import { selectUser } from "@store/sessionReducer";

const UserAuth: FunctionComponent = () => {
  const user = useAppSelector(selectUser);
  const client = useAppSelector(selectClient);

  if (client.kioskFeature.enabled) {
    return null;
  }

  return (
    <div className="user-container">
      {user && <UserAvatar user={user} />}
      {!user && <UserSignIn />}
    </div>
  );
};

export { UserAuth };
